import {
  ClientEntity,
  toTelecomNumbers
} from "@common-core/coat-operational-hierarchy-appsync-model";
import {ClientPhoneNumber} from "./ClientPhoneNumber";

export const uniquePhoneNumbers = (
  collected: ClientPhoneNumber[],
  candidate: ClientPhoneNumber
): ClientPhoneNumber[] => {
  const duplicate = collected.some(
    existing => existing.number === candidate.number
  );
  if (!duplicate) {
    collected.push(candidate);
  }
  return collected;
};

export const phoneNumbersFromClientEntity = (
  entity: ClientEntity
): ClientPhoneNumber[] => {
  return toTelecomNumbers(entity.custPhoneNumber)
    .map(number => ({
      key: `${entity.caId}-${number}`,
      entity,
      number
    }))
    .reduce(uniquePhoneNumbers, []);
};

export const collectClientPhoneNumbers = (
  sources: ClientEntity[]
): ClientPhoneNumber[] => {
  return sources.flatMap(phoneNumbersFromClientEntity);
};
